import React from 'react';
import { Menu, User } from 'lucide-react';
import './Header.css';

const Header = ({ onMenuClick, onAccountClick }) => {
  return (
    <header className="app-header">
      <div className="app-header-container">
        <button className="header-icon-button" onClick={onMenuClick} aria-label="Menu">
          <Menu size={24} />
        </button>

        <div className="header-brand">
          <h1>Farm First Manager</h1>
        </div>

        <button className="header-icon-button" onClick={onAccountClick} aria-label="Account">
          <User size={24} />
        </button>
      </div>
    </header>
  );
};

export default Header;
